module.exports = __webpack_public_path__ + "static/media/xayah.6fee0975.png";